<template>
    <svg :class="iconClass" width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="6.49999" r="1.1" fill="#333333"/>
        <path d="M10.9 9.8H12V17.5M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>